import type { ReactNode } from "react";
import { OrlaMark } from "../brand/OrlaMark";
import "./glow-panel.css";

type Props = {
  children: ReactNode;
  /** "feature" is the large plate with Orla's ring in its corner; "card" is the everyday one. */
  variant?: "card" | "feature";
  /** Panels that are links or buttons brighten under the pointer. */
  interactive?: boolean;
  className?: string;
};

/**
 * The plate from Orla's email signature: near-black, two corners cut away, a hairline of
 * her blue running round the edge and a soft glow of the same blue behind it. The glow is a
 * drop-shadow on the wrapper because a box-shadow cannot follow cut corners.
 */
export function GlowPanel({ children, variant = "card", interactive = false, className }: Props) {
  return (
    <div
      className={["glow-panel", className].filter(Boolean).join(" ")}
      data-variant={variant}
      data-interactive={interactive}
    >
      <div className="glow-panel__edge">
        <div className="glow-panel__body">
          {variant === "feature" ? <OrlaMark className="glow-panel__ring" size={240} /> : null}
          {children}
        </div>
      </div>
    </div>
  );
}
